import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import DesignationSelect from "../DesignationSelect";
import GenderSelect from "../GenderSelect";
import MaritalStatusSelect from "../MaritalStatusSelect";
import EmploymentTypeSelect from "../EmploymentTypeSelect";
import DepartmentSelect from "../DepartmentSelect";

const AllEmployeeAddPopup = ({ onEmployeeAdded }) => {
  const submitButtonRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");
const portalRoot = document.getElementById('root');
const [isLoading, setIsLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      empcode: "",
      joiningDate: null,
      birthDate: null,
      phone: "",
      department: null,
      designation: null,
      gender: null,
      mstatus: null,
      employmentType: null,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      email: Yup.string().email("Invalid email format").required("Email is required"),
      empcode: Yup.string().required("Employee ID is required"),
      joiningDate: Yup.date().required("Joining Date is required"),
      birthDate: Yup.date().required("Birth Date is required"),
      phone: Yup.string().required("Phone is required"),
      department: Yup.object().required("Department is required"),
      designation: Yup.object().required("Designation is required"),
      gender: Yup.object().required("Gender is required"),
      mstatus: Yup.object().required("Marital Status is required"),
      employmentType: Yup.object().required("Employment Type is required"),
    }),
    onSubmit: async (values) => {
      try {
        const requestData = {
          name: values.firstName,
          lastname: values.lastName,
          employeecode: values.empcode,
          email: values.email,
          phone: values.phone,
          department: values.department.value,
          designation: values.designation.value,
          gender: values.gender.value,
          employeeDOJ: values.joiningDate,
          dateOfBirth: values.birthDate,
          martialStatus: values.mstatus.value,
          employmentType: values.employmentType.value,
          empstatus: 'draft'
        };
        setIsLoading(true); // Set loading state to true
        const response = await axios.post(`${apiUrl}/employees/add`, requestData, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        });
    
    
        const newEmployee = response.data;
    
        onEmployeeAdded(newEmployee);
    
        formik.resetForm();
    
        toast.success("Employee added successfully!", {
          position: "top-right"
        });
        setIsLoading(false); // Set loading state to true
        if (submitButtonRef.current) {
          submitButtonRef.current.click();
        }
    
      } catch (error) {
        console.error("Error occurred:", error);
        setIsLoading(false); // Set loading state to true
        if (error.response && error.response.data) {
          const errorMessage = error.response.data.error || "Unknown error occurred.";
          toast.error(errorMessage, {
            position: "top-right",
          });
        } else {
          toast.error("Network error or server unavailable. Please try again.", {
            position: "top-right",
          });
        }
      }
    }
    
  });

  return (
    <>
      <div id="add_employee" className="modal custom-modal fade" role="dialog">
  <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "80%" }}>
    <form onSubmit={formik.handleSubmit} style={{ height: "100%" }}>
      <div className="modal-content h-100">
        <div className="modal-header">
          <h5 className="modal-title">Add Employee</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div
        className="modal-body"
        style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
      >
          <div className="scrollable-container">
            <div className="row">
              {/* First Name */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">First Name <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <input
                      className="form-control"
                      type="text"
                      name="firstName"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div className="text-danger">{formik.errors.firstName}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Last Name */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Last Name <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <input
                      className="form-control"
                      type="text"
                      name="lastName"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div className="text-danger">{formik.errors.lastName}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Gender */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Gender <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <GenderSelect
                      value={formik.values.gender}
                      onChange={(value) => formik.setFieldValue("gender", value)}
                    />
                    {formik.touched.gender && formik.errors.gender ? (
                      <div className="text-danger">{formik.errors.gender}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Marital Status */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Marital Status <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <MaritalStatusSelect
                      value={formik.values.mstatus}
                      onChange={(value) => formik.setFieldValue("mstatus", value)}
                    />
                    {formik.touched.mstatus && formik.errors.mstatus ? (
                      <div className="text-danger">{formik.errors.mstatus}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Birth Date */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Birth Date <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <div className="cal-icon">
                      <DatePicker
                        selected={formik.values.birthDate}
                        onChange={(date) => formik.setFieldValue("birthDate", date)}
                        className="form-control datetimepicker"
                        dateFormat="dd-MM-yyyy"
                      />
                      {formik.touched.birthDate && formik.errors.birthDate ? (
                        <div className="text-danger">{formik.errors.birthDate}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Email <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="text-danger">{formik.errors.email}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Phone */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Phone</label>
                  <div className="col-sm-8">
                    <input
                      className="form-control"
                      type="text"
                      name="phone"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <div className="text-danger">{formik.errors.phone}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Employee ID */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Employee ID <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <input
                      className="form-control"
                      type="text"
                      name="empcode"
                      value={formik.values.empcode}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.empcode && formik.errors.empcode ? (
                      <div className="text-danger">{formik.errors.empcode}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Joining Date */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Joining Date <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <div className="cal-icon">
                      <DatePicker
                        selected={formik.values.joiningDate}
                        onChange={(date) => formik.setFieldValue("joiningDate", date)}
                        className="form-control datetimepicker"
                        dateFormat="dd-MM-yyyy"
                      />
                      {formik.touched.joiningDate && formik.errors.joiningDate ? (
                        <div className="text-danger">{formik.errors.joiningDate}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              {/* Department */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Department <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <DepartmentSelect
                      value={formik.values.department}
                      onChange={(value) => formik.setFieldValue("department", value)}
                    />
                    {formik.touched.department && formik.errors.department ? (
                      <div className="text-danger">{formik.errors.department}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Designation */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Designation <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <DesignationSelect
                      value={formik.values.designation}
                      onChange={(value) => formik.setFieldValue("designation", value)}
                      
                    />
                    {formik.touched.designation && formik.errors.designation ? (
                      <div className="text-danger">{formik.errors.designation}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Employment Type */}
              <div className="col-md-6">
                <div className="form-group row mb-3">
                  <label className="col-sm-4 col-form-label">Employment Type <span className="text-danger">*</span></label>
                  <div className="col-sm-8">
                    <EmploymentTypeSelect
                      value={formik.values.employmentType}
                      onChange={(value) => formik.setFieldValue("employmentType", value)}
                    />
                    {formik.touched.employmentType && formik.errors.employmentType ? (
                      <div className="text-danger">{formik.errors.employmentType}</div>
                    ) : null}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="modal-footer d-flex justify-content-center">
          <button
        type="submit"
        className="btn btn-primary"
        disabled={isLoading} // Disable button while loading
        style={{ position: 'relative' }} // Ensure spinner is properly positioned
      >
        {isLoading ? (
          <>
            <i
              className="fa fa-spinner fa-spin"
              style={{
                marginRight: "8px", // Add spacing between spinner and text
                fontSize: "16px", // Adjust spinner size
              }}
            ></i>
            Saving...
          </>
        ) : (
          "Save"
        )}
      </button>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" type="reset" onClick={() => setShowModal(false)}>Cancel</button>
        </div>
        <div style={{ display: 'none' }}>
          <button ref={submitButtonRef} data-bs-dismiss="modal" aria-label="Close" type="reset">Submit2</button>
        </div>
      </div>
    </form>
  </div>
</div>

    </>
  );
};

export default AllEmployeeAddPopup;
